import { Loader2 } from 'lucide-react';

/**
 * Fallback shown while a code-split admin route chunk is being fetched.
 * Renders inside the existing PortalLayout so the sidebar/header stay put.
 */
export default function AdminPageLoader() {
  return (
    <div className="card p-6 flex items-center gap-3 text-slate-500 text-sm">
      <Loader2 size={16} className="animate-spin" />
      Loading...
    </div>
  );
}
